import { render, staticRenderFns } from "./style_s_5.vue?vue&type=template&id=f561db34&scoped=true&"
import script from "./style_s_5.vue?vue&type=script&lang=js&"
export * from "./style_s_5.vue?vue&type=script&lang=js&"
import style0 from "./style_s_5.vue?vue&type=style&index=0&id=f561db34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561db34",
  null
  
)

export default component.exports